<template>
  <div class="center">
    <img src="@/assets/logo.png"  class="centered" style="width: 30%;padding: 50px"/>
    <h4>Empresa não localizada :(</h4>
  </div>
</template>

<script>
    export default {
        name: "Erro"
    }
</script>



// WEBPACK FOOTER //
// src/components/Paginas/Erro.vue